import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description: "Avoid customers' late payments:",
    title: 'Get paid faster!',
  },
  fr: {
    description: 'Évitez les retards de paiement de vos client·es\xa0:',
    title: 'Faites-vous payer plus vite\xa0!',
  },
} as const);
